export default __webpack_public_path__ + "static/logo_nextjs-db006967f000db531f07dc776bb0853a.png";